export default __webpack_public_path__ + "static/media/modeling_documents_title_en.b4ffaa3f.svg";